import i18n from '../i18n/config';

const t = (namespace, key, params = null) => i18n.getFixedT(null, namespace)(key, params);

export {
  // eslint-disable-next-line import/prefer-default-export
  t,
};
